
app.mapsController = app.mapsController || {};
app.mapsController.defaultAction = {

    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */

    simpleMap : function () {

        function initMap() {
            if(typeof myMap === 'undefined') {
                myMap = {};
            }

            var mylat = myMap.lat || 48.8825201,
                mylong = myMap.long || 2.302213,
                mynoInfoWindow = myMap.noInfoWindow || false,
                myzoom = myMap['zoom'] || 17;

            var styles = [
                {
                    featureType: "poi",
                    stylers: [
                        { visibility: "simplified" }
                    ]
                },
                {
                    featureType: "poi.business",
                    stylers: [
                        { visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "poi.business",
                    elementType: "labels.text",
                    stylers: [
                        { visibility: "off"
                        }
                    ]
                }
            ];

            var styledMap = new google.maps.StyledMapType(styles,
                {name: "Styled Map"});

            var myLatlng = new google.maps.LatLng(mylat, mylong);
            var mapOptions = {
                center: myLatlng,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                },
                disableDefaultUI: true,
                zoomControl: true,
                scrollwheel: true
            };
            var map = new google.maps.Map(document.getElementById('simple-map'), mapOptions);
            map.setZoom(myzoom);

            //Associate the styled map with the MapTypeId and set it to display.
            map.mapTypes.set('map_style', styledMap);
            map.setMapTypeId('map_style');

            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                title: "HOVIA - 104 rue Jouffroy d’Abbans - 75017 Paris",
                icon:'/content/themes/moulinvert/img/marker2.png'
            });

            if (!mynoInfoWindow) {
                var infowindow = new google.maps.InfoWindow({
                    content: "<p id='bodyContent'><strong>Le Moulin Vert</strong><br> 104, rue Jouffroy d'Abbans<br> 75017 Paris</p>"
                });
                marker.addListener('click', function() {
                    infowindow.open(marker.get('map'), marker);
                });
            }
        }

        initMap();
    },

    simpleMap2 : function (myMap, id) {

        console.log(myMap);
        if (typeof myMap === 'undefined') {
            myMap = {};
        }

        var mylat = myMap.lat || 48.8825201,
            mylong = myMap.long || 2.302213,
            mynoInfoWindow = myMap.noInfoWindow || false,
            myzoom = myMap['zoom'] || 17;

        var styles = [
            {
                featureType: "poi",
                stylers: [
                    { visibility: "simplified" }
                ]
            },
            {
                featureType: "poi.business",
                stylers: [
                    { visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.business",
                elementType: "labels.text",
                stylers: [
                    { visibility: "off"
                    }
                ]
            }
        ];

        var styledMap = new google.maps.StyledMapType(styles,
            {name: "Styled Map"});

        var myLatlng = new google.maps.LatLng(mylat, mylong);
        var mapOptions = {
            center: myLatlng,
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
            },
            disableDefaultUI: true,
            zoomControl: true,
            scrollwheel: true
        };
        var map = new google.maps.Map(document.getElementById(id), mapOptions);
        map.setZoom(myzoom);

        //Associate the styled map with the MapTypeId and set it to display.
        map.mapTypes.set('map_style', styledMap);
        map.setMapTypeId('map_style');

        var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: "HOVIA - 104, rue Jouffroy d'Abbans - 75017 Paris",
            icon:'/wp-content/themes/moulinvert/img/marker2.png'
        });

        if (!mynoInfoWindow) {
            var infowindow = new google.maps.InfoWindow({
                content: "<p id='bodyContent'><strong>Le Moulin Vert</strong><br /> 104, rue Jouffroy d'Abbans<br> 75017 Paris</p>"
            });
            marker.addListener('click', function() {
                infowindow.open(marker.get('map'), marker);
            });
        }
    },

    dynMap : function () {
        var map;
        var styles = [
            {
                featureType: "administrative",
                elementType: "geometry",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "administrative.country",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "administrative.land_parcel",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "administrative.neighborhood",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "landscape",
                stylers: [
                    { color: "#e0efef" }
                ]
            },
            {
                featureType: "poi",
                stylers: [
                    { visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    { visibility: "off"
                    }
                ]
            },
            {
                featureType: "road",
                stylers: [
                    { color: "#ffffff" }
                ]
            },
            {
                featureType: "road",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "road",
                elementType: "labels.icon",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "road.arterial",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "road.arterial",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    { color: "#ffffff" }
                ]
            },
            {
                featureType: "road.highway",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "road.local",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "transit",
                stylers: [
                    { visibility: "off" }
                ]
            },
            {
                featureType: "water",
                stylers: [
                    { color: "#7dcdcd" }
                ]
            },
            {
                featureType: "water",
                elementType: "labels.text",
                stylers: [
                    { visibility: "off" }
                ]
            }
        ];
        var markers = new Array();
        var infowindows = new Array();
        var zoneMarqueurs;
        var map;

        function initMap() {

            var styledMap = new google.maps.StyledMapType(styles,
                {name: "Styled Map"});


            zoneMarqueurs = new google.maps.LatLngBounds();

            var image = {
                url: '/content/themes/moulinvert/img/marker.png',
                // This marker is 20 pixels wide by 32 pixels high.
                size: new google.maps.Size(13, 21),
                // The origin for this image is (0, 0).
                origin: new google.maps.Point(0, 0),
                // The anchor for this image is the base of the flagpole at (0, 32).
                anchor: new google.maps.Point(0, 21)
            };


            var mapOptions = {
                // zoom: 11,
                center: new google.maps.LatLng(48.1159675, -1.7235596),
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                },
                disableDefaultUI: true,
                zoomControl: true,
                scrollwheel: true
            };

            map = new google.maps.Map(document.getElementById('dynamic-map'), mapOptions);

            //Associate the styled map with the MapTypeId and set it to display.
            map.mapTypes.set('map_style', styledMap);
            map.setMapTypeId('map_style');

            //Put markers on map.
            for( var i = 0, I = tableauMarqueurs.length; i < I; i++ ) {

                var latlng = tableauMarqueurs[i],
                    latitude = latlng.lat,
                    longitude = latlng.lng,
                    title = latlng.title,
                    adress = latlng.adress,
                    tel = latlng.tel,
                    mail = latlng.mail,
                    url = latlng.url;

                var optionsMarqueur = {
                    map: map,
                    position: new google.maps.LatLng( latitude, longitude ),
                    icon: image
                };

                var marker = new google.maps.Marker( optionsMarqueur );
                markers[i] = marker;
                zoneMarqueurs.extend( marker.getPosition() );

                var contentString = '<div id="content">'+
                    '<div id="siteNotice">'+
                    '</div>'+
                    '<div id="bodyContent" class="infowindowBody">'+
                    '<strong class="infowindowTitle">'+ title +'</strong>'+
                    '<p>' + adress + '</p>'+
                    '<p>' + tel + '<br>'+
                    '<a href="mailto:'+mail+'">' + mail + '</a></p>'+
                    '<a class="infowindowPermalink" href="' + url + '">accéder à la fiche de l\'établissement</a>'+
                    '</div>'+
                    '</div>';

                attachSecretMessage(i, marker, contentString);
            }

            map.fitBounds( zoneMarqueurs );
        }

        function attachSecretMessage(id, marker, content) {
            infowindows[id] = new google.maps.InfoWindow({
                content: content
            });

            marker.addListener('click', function() {
                for (i=0; i < tableauMarqueurs.length; i++) {

                    if(id != tableauMarqueurs[i].id) {
                        infowindows[i].close();
                    }
                }
                infowindows[id].open(marker.get('map'), marker);
            });
        }

        function etablMapAction() {
            var depSelectOpt = [];
            var etabSelectOpt = [];

            function closeInfos() {
                for (i=0; i < tableauMarqueurs.length; i++) {
                    infowindows[i].close();
                }
            }

            function showMarker(id) {
                markers[id].setVisible(true);
                tableauMarqueurs[i].visible = true;
            }

            function hideMarker(id) {
                markers[id].setVisible(false);
                tableauMarqueurs[i].visible = false;
                infowindows[id].close();
            }

            function point (id,pub,dept) {
                this.id = id;
                this.dept = dept;
                this.pub = pub;
                this.visible = true;
            }

            function unique(array){
                return array.filter(function(el, index, arr) {
                    return index == arr.indexOf(el);
                });
            }

            function pad(n) {
                return (n < 10) ? ("0" + n) : n;
            }

            function mapdisableSelect(select, array) {

                select.children("option").each(function() {
                    if ($(this).val() != '*') {
                        $(this).attr("disabled", "disabled").hide();
                    }
                });

                for (var i = 0; i < array.length; i++) {
                    select.children('option[value="' + array[i] + '"]').removeAttr("disabled").show();
                }

            }

            function filter() {
                dept = $('#departements').val();
                pub = $('#publics').val();
                etab = $('#etablissements').val();
                activeMarker = 0;

                for (i=0; i < tableauMarqueurs.length; i++)
                {
                    // Cache tous les établissements sauf celui sélectionné
                    if (etab !='*' && tableauMarqueurs[i].id != etab)
                    {
                        hideMarker(i);
                    }
                    else {
                        if (tableauMarqueurs[i].dept != dept && dept!='*'){
                            hideMarker(i);
                        }
                        else if (tableauMarqueurs[i].pub != pub && pub!='*') {
                            hideMarker(i);
                        }
                        else
                        {
                            showMarker(i);
                            depSelectOpt.push(pad(parseInt(tableauMarqueurs[i].dept)));
                            etabSelectOpt.push(parseInt(tableauMarqueurs[i].id));
                            activeMarker++;
                        }
                    }
                }

                console.log(unique(depSelectOpt));

                mapdisableSelect($('#departements'), unique(depSelectOpt));
                mapdisableSelect($('#etablissements'), unique(etabSelectOpt));
                depSelectOpt = [];
                etabSelectOpt = [];

                map.fitBounds( zoneMarqueurs );
            }

            function reset() {
                document.location.reload(true);
                // var $allDeptOpt = $('#departements option[value="*"]'),
                //     $allPubOpt = $('#publics option[value="*"]'),
                //     $allEtabOpt = $('#etablissements option[value="*"]');
                //
                // // Remove disabled attr
                // $('#departements, #publics, #etablissements').children("option").each(function() {
                //     $(this).removeAttr("disabled");
                // });
                //
                // // Set '*' value on 'selected'
                // $allDeptOpt.attr('selected', true);
                // $allPubOpt.attr('selected', true);
                // $allEtabOpt.attr('selected', true);
                //
                // // Update Custom Select text value
                // $('#departements').trigger('render');
                // $('#publics').trigger('render');
                // $('#etablissements').trigger('render');
                //
                // for (i=0; i < tableauMarqueurs.length; i++)
                // {
                //     // Affiche tous les établissements
                //     showMarker(i);
                // }
            }



            $('.filterMap').change(function() {
                filter();
            });

            $('#resetMapFilters').on('click', function(){
                reset();
            });
        }

        initMap();
        // Page Carte des établissements
        if ($('body').hasClass('la-carte-des-etablissements')) {
            etablMapAction();
        }
    },

};

$(document).ready(function(){

    if ($('#simple-map').length > 0) {
        app.mapsController.defaultAction.simpleMap();
    }
    if ($('#dynamic-map').length > 0) {
        app.mapsController.defaultAction.dynMap();
    }
});